import React, { Component } from 'react';
import { View, StyleSheet, Text, ScrollView } from 'react-native';
import { connect } from 'react-redux';
import { openNutritionStepsVideo } from '../actions';
import { VideoDisplay, toggleDieticianModal } from '../../ui';
import moment from 'moment-timezone';
import { translate } from 'react-i18next';
import { NutritionStepWithVideo } from '../components';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

class NutritionGuide extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoName: null,
      isVideoVisible: false,
    };
    const { t } = this.props;
    this.nutritionVideoSteps = [
    {
      title: t('personalisedNutrition'),
      description: t('scienceAndFoodTypes'),
      duration: 120,
      imageName: require('../../assets/images/nutrition-step-2.png'),
    },
    {
      title: t('lifeStyleOptions'),
      description: t('lifeStyleOptionsDescription'),
      duration: 44,
      imageName: require('../../assets/images/nutrition-step-3.png'),
    },
  ];
  }
  openVideo = (videoData, nutritionStepInfo) => {
    this.setState({ videoName: videoData, isVideoVisible: true });
    this.props.openNutritionStepsVideo(nutritionStepInfo.title);
  }

  closeVideo = () => {
    this.setState({ isVideoVisible: false });
  }

  getVideoFileName = (step) => {
    const { userProfile } = this.props;
    if (step === 1) {
      return 'step1';
    } else if (step === 3) {
      return moment.tz.guess().includes('Australia') ? 'step3_aus' : 'step3';
    }
    return `step${step}-${userProfile.gender}-${userProfile.longTermGoal}`;
  }

  render() {
    const { isVideoVisible, videoName } = this.state;
    const { t, toggleDieticianModal } = this.props;
    return isVideoVisible ? (
      <View style={[StyleSheet.absoluteFill, { flex: 1, alignSelf: 'center' }, { zIndex: 100 }]}>
        <VideoDisplay
          closeVideo={this.closeVideo}
          isVideoVisible={isVideoVisible}
          fullscreenOn={isVideoVisible}
          videoName={videoName}
        />
      </View>
    ) : (
      <ScrollView style={{ flex: 1, zIndex: 1 }}>
        <Text style={styles.watchVideosText}>{t('watchTheseVideos')}</Text>
        {this.nutritionVideoSteps.map((singleItem, ind) => {
          return (
            <NutritionStepWithVideo
              openVideo={this.openVideo}
              videoName={this.getVideoFileName(ind + 1)}
              nutritionStepInfo={singleItem}
              stepNumber={ind + 1}
            />
          );
        })}
        <View>
          <Text
            onPress={() => {
              toggleDieticianModal(true);
            }}
            style={styles.nutritionLink}
          >
            <Text style={styles.nutritionLink}>
              {t('learnMoreAboutTheNutritionScience')}
            </Text>
            <Text style={styles.nutritionSourceLink}> {t('here')}.</Text>
          </Text>
        </View>
      </ScrollView>
    );
  }
}

const styles = StyleSheet.create({
  watchVideosText: {
    ...Theme.textStyle.small,
    paddingVertical: defaultScale(15),
  },
  nutritionSourceLink: {
    ...Theme.textStyle.small,
    color: Theme.PRIMARY,
  },
  nutritionLink: {
    ...Theme.textStyle.small,
    paddingVertical: defaultScale(15),
  },
});

const mapDispatchToProps = (dispatch) => {
  return {
    openNutritionStepsVideo: (stepName) =>
      dispatch(openNutritionStepsVideo(stepName)),
    toggleDieticianModal: (visible) => dispatch(toggleDieticianModal(visible)),
  };
};

export default translate(['nutrition'], { wait: true })(
  connect(null, mapDispatchToProps)(NutritionGuide),
);
